import React from "react";
import SidebarObject from "./Component";
import useStores from "../../../../utils/useStores";
import { observer } from "mobx-react";
import { QuizObject } from "../../../../store/modquiz/quiz_objects/quiz-object";

interface SidebarObjectContainerProps {
    subject_user: string;
    subject_slug: string;
    subjectHashKey: string;
    subject: any;
    hasCreateAccess: boolean;
    location?: any;
};

const SidebarObjectContainer = observer(
    ({
        subject,
        subject_user,
        subject_slug,
        subjectHashKey,
        hasCreateAccess,
        location
    }: SidebarObjectContainerProps) => {
        const rootStore = useStores();

        let createObject = (title: string, cb: Function) => {
            rootStore.objectStore.create(
                subject_user,
                subject_slug,
                title,
                function(success: boolean, res: any) {
                    cb();
                }
            );
        };

        let quiz_objects = rootStore.subjectStore.nestedQuizObjects(
            subjectHashKey
        );

        let fromQuizzer = (location && location.search && location.search.includes(
            "from_quizzer=true"
        ))
        return (
            <SidebarObject
                fromQuizzer={fromQuizzer}
                createObject={createObject}
                subjectHashKey={subjectHashKey}
                subject={subject}
                quiz_objects={quiz_objects}
                hasCreateAccess={hasCreateAccess}
            />
        );
    }
);

export default SidebarObjectContainer;
